const CapitalizeFirstLetter = (text, fallback = "Not Available") => {
  if (text === null || text === undefined || text.trim() === "") {
    return fallback;
  }
  if (typeof text !== "string") {
    return fallback;
  }

  // Trim and split into words (handles multiple spaces)
  return text
    ?.trim()
    ?.split(/\s+/)
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    ?.join(" ");
};

export default CapitalizeFirstLetter;
